import { spacing } from '../../../shared/theme/spacing'
import { ticketColors } from '../../../shared/theme/ticketColors';
import { ticketSurfaces } from '../../../shared/ticket/ticketSurfaces.styles';

export const posCheckoutLayoutStyleDefs = {
  checkoutWideColumns: {
    flex: 1,
    flexDirection: 'row',
    minHeight: 0,
    gap: spacing.md,
    justifyContent: 'center',
    alignItems: 'stretch',
  },

  checkoutTicketColumn: {
    flexGrow: 1,
    flexShrink: 1,
    minWidth: 380,
    maxWidth: 520,
    alignSelf: 'flex-start',
  },

  checkoutTicketColumnContent: {
    gap: spacing.md,
    paddingBottom: spacing.md,
  },

  checkoutRailColumn: {
    ...ticketSurfaces.paperSheet,
    flexGrow: 1,
    flexShrink: 0,
    minWidth: 320,
    maxWidth: 420,
    minHeight: 0,
    alignSelf: 'stretch',
    borderLeftWidth: 1,
    borderLeftColor: ticketColors.ruleSoft,
    padding: spacing.sm,
    gap: spacing.xs,
    justifyContent: 'flex-start',
  },

  /** Crece con el alto disponible del rail; el total queda fijo abajo. */
  checkoutRailScroll: {
    flexGrow: 1,
    flexShrink: 1,
    minHeight: 0,
    maxHeight: 480,
  },

  checkoutRailScrollContent: {
    gap: spacing.sm,
    paddingBottom: spacing.md,
  },

  checkoutSectionBlock: {
    gap: spacing.xs,
  },
} as const;
